import { gql } from "apollo-boost";

export const CREATE_ATTRIBUTE = gql`
mutation CreateAttribute($data: AttributeInput!) {
  createAttribute(data: $data) {
    id
    name
    shop {
      id
      name
    }
  }
}
`

export const UPDATE_ATTRIBUTE = gql`
mutation UpdateAttribute($data: AttributeInput!, $where: AttributeWhereInputOne!) {
  updateAttribute(data: $data, where: $where) {
    id
  }
}
`

export const DELETE_ATTRIBUTE = gql`
mutation DeleteAttribute($where: AttributeWhereInputOne!) {
  deleteAttribute(where: $where) {
    id
  }
}
`
